import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IPerson } from 'src/app/models/iperson.interface';

@Component({
  selector: 'app-person-info-view',
  templateUrl: './person-info-view.component.html',
  styleUrls: ['./person-info-view.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonInfoViewComponent implements OnInit {
  @Input() person: IPerson;
  @Input() isReadOnly: boolean = true;
  @Input() isDelete: boolean = false;
  @Output() delete = new EventEmitter<IPerson>();
  @Output() edit = new EventEmitter<IPerson>();
  @Output() newIacmac = new EventEmitter<IPerson>();
  @Output() editIacmac = new EventEmitter<IPerson>();
  constructor() { }

  ngOnInit(): void {
  }

  onEdit() {
    this.edit.emit(this.person);
  }

  onDelete() {
    this.delete.emit(this.person)
  }

  onNewIacmac() {
    this.newIacmac.emit(this.person);
  }

  onEditIacmac() {
    this.editIacmac.emit(this.person);
  }

}
